import {IPaylodAction} from '../interfaces/dispatchers'
import ErrorActions from '../enums/ActionTypes/ErrorActions'

const initState: Array<Error> = []
let stateSnapshot: Array<Error>

const errors = (state: Array<Error> = initState, action: IPaylodAction<Error>) => {
  switch (action.type) {
    case ErrorActions.ERROR:
    case ErrorActions.STORE_ACCESS_ERROR:
    case ErrorActions.REQUEST_ERROR:
      stateSnapshot = [...state, action.payload]
      break
    default:
      stateSnapshot = [...state]
      break
  }
  return stateSnapshot
}
export default errors
